import {featureAbbr} from "../../configs/constants"
const  messages = {
  [`${featureAbbr.toLowerCase()}.count`]: "order count",
};

export default messages
